/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { IConnectionLog, IDnsResponse } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

interface IDnsLoadBalancerInfo extends Pick<IConnectionLog, 'gslbservice' | 'gslbpool_name'> {
    recursion_available?: IDnsResponse['recursion_available'];
    query_or_response?: IDnsResponse['query_or_response'];
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting DNS Load Balance info from an L4 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'dnsLoadBalancerInfo',
})
export class DnsLoadBalancerInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IConnectionLog): IDnsLoadBalancerInfo {
        if (!log) {
            return {};
        }

        const {
            gslbservice,
            gslbpool_name,
            dns_response: {
                recursion_available,
                query_or_response,
            } = {},
        } = log;

        return {
            gslbservice,
            gslbpool_name,
            recursion_available,
            query_or_response,
        };
    }
}
